type UnknownObject = Record<string, unknown>;
type UnknownArrayOrObject = unknown[] | UnknownObject;

const getDirtyFields = (
  dirtyFields: UnknownArrayOrObject | boolean,
  allValues: UnknownArrayOrObject | unknown
): UnknownArrayOrObject | unknown => {
  if (dirtyFields === true || Array.isArray(dirtyFields)) {
    return allValues;
  }

  const dirtyFieldsObject = dirtyFields as UnknownObject;
  const allValuesObject = allValues as UnknownObject;

  return Object.fromEntries(
    Object.keys(dirtyFieldsObject).map((key) => {
      const dirtyFlds = dirtyFieldsObject[key] as any;
      return [key, getDirtyFields(dirtyFlds, allValuesObject[key])];
    })
  );
};

export default getDirtyFields;
